import Axios, { AxiosRequestConfig } from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
export default cookies;

export const getTokenFromCookies = () => {
  return cookies.get("authToken"); // Adjust this based on your cookie setup
};

const defaultAxios = Axios.create({
  headers: {
    "Content-type": "application/json",
    "X-Branch": `${import.meta.env.VITE_X_BRANCH}`,
    "X-Data-Source": `${import.meta.env.VITE_X_DATA_SOURCE}`,
  },
});

defaultAxios.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

defaultAxios.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    return Promise.reject(err);
  },
);

/**
 * Thrown when a screen that still calls Xano is opened after the app moved to
 * the new backend. Without this the request goes out unauthenticated, Xano
 * refuses it, and the screen sits on a spinner forever.
 */
export class NotMigratedError extends Error {
  constructor(url?: string) {
    super(
      "This screen still uses the old Xano backend and has not been migrated yet" +
        (url ? ` (${url})` : ""),
    );
    this.name = "NotMigratedError";
  }
}

defaultAxios.interceptors.request.use((config) => {
  // Deliberately not `authToken`: the session writes that one so the legacy
  // screens' guards pass. A Xano call needs a Xano token, which nothing sets
  // any more — so every unmigrated endpoint fails here, loudly and at once,
  // rather than going out with a token Xano will reject.
  let token: string | null = null;
  try {
    token = JSON.parse(localStorage.getItem("xano.authToken") as string);
  } catch {
    token = null;
  }
  if (!token) {
    // Fail immediately and visibly rather than hanging or 401-ing silently.
    return Promise.reject(new NotMigratedError(config.url));
  }
  if (config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function apiClient(
  method: string,
  url: string,
  options: AxiosRequestConfig<any> = {},
) {
  const { data = {}, headers = {}, params = {}, ...rest } = options;
  return defaultAxios({
    url,
    data,
    method,
    params,
    headers,
    ...rest,
  });
}

export const apis = {
  get: (url: string, args: AxiosRequestConfig<any>) =>
    apiClient("get", url, args),
  post: (url: string, args: AxiosRequestConfig<any>) =>
    apiClient("post", url, args),
  put: (url: string, args: AxiosRequestConfig<any>) =>
    apiClient("put", url, args),
  patch: (url: string, args: AxiosRequestConfig<any>) =>
    apiClient("patch", url, args),
  delete: (url: string, args: AxiosRequestConfig<any>) =>
    apiClient("delete", url, args),
};
